/* ------------------------------------------------------------------
   List of blog posts, newest first. The /blog page is built from this.
   To add a post later: create its page file, add an entry here,
   add its <Route> in App.js and its address to public/sitemap.xml.
------------------------------------------------------------------- */
export const BLOG_POSTS = [
  {
    slug: "repair-or-replace-appliance",
    title: "Should I Repair or Replace My Appliance? Advice From Appliance Repair Technicians",
    description:
      "Repair or replace? How our technicians decide, with appliance lifespans, real examples and the hidden costs of buying new. Plainfield, Naperville & nearby.",
    date: "2026-11-03",
    dateLabel: "November 3, 2026",
    readTime: "5 min read",
    category: "Repair advice",
    excerpt:
      "Most appliances are fixable, but not every repair makes sense. Here's how our technicians decide, with real examples from Plainfield, Naperville and Bolingbrook.",
  },
  {
    slug: "50-50-payment-appliance-repair",
    title: "The 50/50 Payment Plan: A Fair Way to Pay for Appliance Repair",
    description:
      "Pay 50% when we order your part and 50% once your appliance works. How our 50/50 payment plan works.",
    date: "2026-10-29",
    dateLabel: "October 29, 2026",
    readTime: "4 min read",
    category: "Pricing & payments",
    excerpt:
      "When a repair needs a part, you pay half when we order it and the other half once your appliance is working again.",
  },
];

export const postPath = (slug) => `/blog/${slug}`;